```vue
<template>
  <div class="recordWrap">
    <div class="mainCom w1200 clearfix">
      <!-- 左侧菜单 -->
      <div class="mainComL">
        <menuWX></menuWX>
      </div>

      <!-- 右侧内容 -->
      <div class="mainComR">
        <div class="recordBar bgWhite">

          <!-- 标题 -->
          <div class="titleWrap">
            <span class="title">数据查询</span>
            <span class="back" @click="goBack">返回上级</span>
          </div>

          <!-- Tab -->
          <div class="tagWrap">
            <span v-for="item in tagList" :key="item.type" :class="{ active: tagActive === item.type }"
              @click="tagChange(item)">
              {{ item.name }}
            </span>
          </div>

          <!-- 搜索区域 -->
          <div class="searchWrap">

            <div class="searchBar">
              <el-form ref="form" :model="searchForm" label-width="100px">

                <!-- 游戏账号 -->
                <el-form-item class="name" label="游戏账号:">
                  <el-input v-model="userInfo.username" disabled></el-input>
                </el-form-item>

                <!-- 状态 -->
                <el-form-item v-if="currentTag.type !== 7 && currentTag.type !== 10" class="status" label="状态：">
                  <!-- 赠予记录 -->
                  <el-select v-if="currentTag.type === 8" v-model="searchForm.status" placeholder="请选择状态">
                    <el-option v-for="item in grantState" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>

                  <!-- 普通记录 -->
                  <el-select v-else v-model="searchForm.status" placeholder="请选择状态">
                    <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 订单号 -->
                <el-form-item v-if="currentTag.type === 2" class="orderNum" label="订单号:">
                  <el-input v-model="searchForm.orderSn" clearable></el-input>
                </el-form-item>

                <!-- 公告类型 -->
                <el-form-item v-if="currentTag.type === 1" class="noticeType" label="公告类型:">
                  <el-select v-model="searchForm.noticeType" placeholder="请选择公告类型" clearable>
                    <el-option v-for="item in noticeType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 白金币记录 -->
                <el-form-item v-if="currentTag.type === 10" label-width="120px" label="白金币类型:">
                  <el-select v-model="searchForm.moneyType" style="width: 220px;" placeholder="请选择白金币类型" clearable>
                    <el-option v-for="item in moneyType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 时间 -->
                <el-form-item class="time" label="时间:">
                  <el-date-picker v-model="time" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" align="right" clearable />
                </el-form-item>

              </el-form>
            </div>

            <!-- 查询按钮 -->
            <div class="searchBtn">
              <el-button type="primary" @click="search">
                查询
              </el-button>
            </div>

          </div>
          <div v-if="currentTag.type === 10" class="hit">白金币相关记录将从 2026 年 09 月 04 日 14:00 开始展示，此前记录不予呈现。</div>
          <!-- 表格 -->
          <div class="tableWrap">
            <el-table :data="tableData" border stripe style="width: 100%" v-loading="loading"
              element-loading-text="加载中...">
              <el-table-column v-for="item in currentTableHead" :key="item.prop" :prop="item.prop" :label="item.label"
                :min-width="160" :resizable="false" :formatter="item.formatter" />
            </el-table>
          </div>

          <!-- 分页 -->
          <div class="pageWrap">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="pageNum"
              :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuWX from '@/components/Menu'
import axios from 'axios'
import Cookies from 'js-cookie'
import eventBus from '@/common/bus.js'

export default {
  name: 'record',

  components: {
    menuWX
  },

  data() {
    return {
      /**
       * 当前记录类型
       *
       * 1  公告
       * 2  充值
       * 10 白金币
       * 3  消费
       * 4  划分
       * 5  泡点
       * 6  积分
       * 7  安全
       * 8  赠予
       */
      tagActive: Number(this.$route.query.type) || 1,

      tagList: [
        { name: '公告记录', type: 1 },
        { name: '充值记录', type: 2 },
        { name: '白金币记录', type: 10 },
        { name: '消费记录', type: 3 },
        { name: '划分记录', type: 4 },
        { name: '泡点记录', type: 5 },
        { name: '积分记录', type: 6 },
        { name: '赠予记录', type: 8 },
        { name: '安全日志', type: 7 }
      ],

      // 普通状态
      status: [
        { label: '全部', value: 0 },
        { label: '成功', value: 1 },
        { label: '失败', value: 2 }
      ],

      // 赠予状态
      grantState: [
        { label: '已完成', value: 1 },
        { label: '已拒收', value: 2 },
        { label: '待收取', value: 3 }
      ],

      // 公告类型
      noticeType: [
        { label: '普通公告', value: 1 },
        { label: '超级公告', value: 2 },
        { label: '霸屏公告', value: 3 },
        { label: '特权公告', value: 4 }
      ],
      //白金币类型
      moneyType:[
       { label: '白金币', value: 1 },
        { label: '绑定白金币', value: 0 },
      ],

      // 时间快捷选择
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()

              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 7
              )

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()

              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 30
              )

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()

              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 90
              )

              picker.$emit('pick', [start, end])
            }
          }
        ]
      },

      // 时间
      time: '',

      // 查询参数
      searchForm: {
        startTime: '',
        endTime: '',
        orderSn: '',
        noticeType: '',
        status: 0,
        moneyType:''
      },

      // 分页
      pageNum: 1,
      pageSize: 20,
      total: 0,

      // 表头
      tableHead: {
        // 公告
        1: [
          { prop: 'noticeType', label: '公告类型' },
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'num', label: '发送数量' },
          { prop: 'status', label: '状态' }
        ],

        // 充值
        2: [
          { prop: 'orderSn', label: '订单号' },
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'money', label: '金额' },
          { prop: 'status', label: '状态' }
        ],

        // 消费
        3: [
          { prop: 'itemName', label: '道具名称' },
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'money', label: '金额（白金币）' },
          { prop: 'status', label: '状态' }
        ],

        // 划分
        4: [
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'money', label: '金额（白金币）' },
          { prop: 'status', label: '状态' }
        ],

        // 泡点
        5: [
          { prop: 'itemName', label: '道具名称' },
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'flag', label: '获得/消耗' },
          { prop: 'money', label: '泡点' },
          { prop: 'status', label: '状态' }
        ],

        // 积分
        6: [
          { prop: 'itemName', label: '道具名称' },
          { prop: 'date', label: '时间' },
          { prop: 'username', label: '账号' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'money', label: '积分' },
          { prop: 'status', label: '状态' }
        ],

        // 安全日志
        7: [
          { prop: 'username', label: '账号' },
          { prop: 'date', label: '登录时间' },
          { prop: 'address', label: '登陆地' },
          { prop: 'source', label: '登录平台' },
          { prop: 'ip', label: '登录IP' }
        ],

        // 赠予
        8: [
          { prop: 'itemName', label: '道具名称' },
          { prop: 'date', label: '时间' },
          { prop: 'targetUsername', label: '赠与账号' },
          { prop: 'num', label: '赠予数量' },
          { prop: 'gameArea', label: '游戏大区' },
          { prop: 'status', label: '状态' }
        ],

        // 白金币
        10: [
          { prop: 'username', label: '用户名' },
          { prop: 'date', label: '时间' },
          { prop: 'money', label: '金额' },
          {
            prop: 'moneyType',
            label: '白金币类型',
            formatter: (row, column, cellValue) => {
              return Number(cellValue) === 1
                ? '白金币'
                : '绑定白金币'
            }
          },
          { prop: 'surplus', label: '剩余白金币' },
          { prop: 'flag', label: '分类' },
          { prop: 'itemName', label: '备注' }
        ]
      },

      tableData: [],

      userInfo: {
        verifyInfo: {},
        vipInfo: {},
        wallteInfo: {}
      },

      loading: false
    }
  },

  computed: {
    /**
     * 当前 Tab
     */
    currentTag() {
      return (
        this.tagList.find(
          item => item.type === this.tagActive
        ) || this.tagList[0]
      )
    },

    /**
     * 当前表头
     */
    currentTableHead() {
      return this.tableHead[this.tagActive] || []
    }
  },

  created() {
    // 使用箭头函数方便销毁监听
    this.handleRecordEvent = data => {
      if (!data) return

      this.tagChange(data)
    }

    eventBus.$on('Record', this.handleRecordEvent)
  },

  mounted() {
    document.documentElement.scrollTop = 0

    const userInfo = localStorage.getItem('userInfo')

    if (userInfo) {
      try {
        this.userInfo = JSON.parse(userInfo)
      } catch (e) {
        console.warn('userInfo 解析失败', e)
      }
    }

    this.getRecordData()
  },

  beforeDestroy() {
    eventBus.$off('Record', this.handleRecordEvent)
  },

  methods: {
    /**
     * 数字补 0
     */
    ZeroFn(num) {
      return num < 10 ? '0' + num : num
    },

    /**
     * 格式化时间
     */
    formatTime(time) {
      if (!time) return ''

      const y = this.ZeroFn(time.getFullYear())
      const mo = this.ZeroFn(time.getMonth() + 1)
      const d = this.ZeroFn(time.getDate())
      const h = this.ZeroFn(time.getHours())
      const m = this.ZeroFn(time.getMinutes())
      const s = this.ZeroFn(time.getSeconds())

      return `${y}-${mo}-${d} ${h}:${m}:${s}`
    },

    /**
     * 查询
     */
    search() {
      if (this.time && this.time.length === 2) {
        this.searchForm.startTime = this.formatTime(
          new Date(this.time[0])
        )

        this.searchForm.endTime = this.formatTime(
          new Date(this.time[1])
        )
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }

      // 查询重新从第一页开始
      this.pageNum = 1

      this.getRecordData()
    },

    /**
     * 获取记录
     */
    getRecordData() {
      this.loading = true

      axios({
        method: 'post',
        url: '/record/getRecordList',

        headers: {
          token: Cookies.get('wx_token')
        },

        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,

          queryRequest: {
            ...this.searchForm
          },

          // 这里直接使用 type
          // 不再 +1
          type: this.tagActive,

          platForm: 'web',

          userId: Cookies.get('wx_userId')
        }
      })
        .then(res => {
          if (res.data.state !== 200) {
            this.$message.error(
              res.data.message || '获取数据失败'
            )

            this.tableData = []
            this.total = 0

            return
          }

          const data = res.data.data || {}

          this.total = Number(data.counts || 0)

          /**
           * 根据 type 判断接口返回的数据
           */
          switch (this.tagActive) {
            // 公告
            case 1:
              this.tableData =
                data.noticeLogResponseList || []
              break

            // 充值
            case 2:
              this.tableData =
                data.rechargeLogOneList || []
              break

            // 安全
            case 7:
              this.tableData =
                data.loginLogResponseList || []
              break

            // 赠予
            case 8:
              this.tableData =
                data.giftLogResponseList || []
              break

            // 其它
            case 3:
            case 4:
            case 5:
            case 6:
            case 10:
              this.tableData =
                data.recordLogList || []
              break

            default:
              this.tableData = []
          }
        })
        .catch(err => {
          console.error('获取记录失败:', err)

          this.tableData = []
          this.total = 0

          this.$message.error(
            err.message || '网络请求失败'
          )
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 返回
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * 切换 Tab
     */
    tagChange(item) {
      if (!item) return

      /**
       * 兼容 eventBus 传 type 的情况
       */
      if (typeof item === 'number' || typeof item === 'string') {
        item = this.tagList.find(
          tag => tag.type === Number(item)
        )
      }

      if (!item) return

      // 更新当前类型
      this.tagActive = Number(item.type)

      // 切换记录时重置分页
      this.pageNum = 1

      // 切换记录时清理部分查询条件
      this.resetSearchByType()

      // 更新路由参数
      this.updateRoute()

      // 获取数据
      this.getRecordData()
    },

    /**
     * 根据 Tab 重置查询条件
     */
    resetSearchByType() {
      // 状态
      if (this.tagActive === 8) {
        this.searchForm.status = 1
      } else if (this.tagActive === 7) {
        // 安全日志没有状态
        this.searchForm.status = 0
      } else {
        this.searchForm.status = 0
      }

      // 非充值清空订单号
      if (this.tagActive !== 2) {
        this.searchForm.orderSn = ''
      }

      // 非公告清空公告类型
      if (this.tagActive !== 1) {
        this.searchForm.noticeType = ''
      }
    },

    /**
     * 同步 URL
     */
    updateRoute() {
      const query = {
        ...this.$route.query,
        type: String(this.tagActive)
      }

      this.$router.replace({
        query
      }).catch(() => { })
    },

    /**
     * 分页
     */
    handleCurrentChange(val) {
      this.pageNum = val

      this.getRecordData()
    }
  }
}
</script>

<style lang="less">
.recordBar {
  .searchBar {
    .el-form {
      overflow: hidden;

      .el-form-item {
        padding-right: 10px;
        margin-bottom: 15px;
        float: left;
        width: 50%;
        box-sizing: border-box;

        .el-form-item__label {
          font-size: 18px;
        }

        .el-select {
          width: 289px;

          .el-input__inner {
            font-size: 18px;
          }
        }
      }

      .name {
        .el-input__inner {
          border: none;
          border-bottom: 1px dashed #333333;
          border-radius: 0;
          font-size: 18px;
        }

        .is-disabled {
          .el-input__inner {
            background: #ffffff;
            cursor: text;
            color: #333333;
          }
        }
      }

      .time {
        .el-date-editor--datetimerange.el-input__inner {
          width: 290px;
        }

        .el-date-editor {
          .el-range__icon {
            display: none;
          }

          .el-range-input {
            width: 44%;
          }
        }
      }
    }
  }

  .searchBtn {
    .el-button {
      width: 100%;

      span {
        font-size: 16px;
      }
    }
  }

  .hit{
    padding: 10px 5px 20px;
    font-size: 16px;
    color: red;
  }
  .tableWrap {
    .el-table--border {
      border: 1px solid #D22190;
    }

    .has-gutter {

      tr,
      th {
        background: #D22190;
      }

      th {
        border-right: none;

        .cell {
          font-size: 22px;
          color: #ffffff;
          line-height: 35px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }

    td {
      text-align: center;

      .cell {
        white-space: nowrap;
      }
    }

    .el-table--striped {
      .el-table__body {
        tr.el-table__row--striped {
          td.el-table__cell {
            background: rgba(210, 33, 144, 0.1);
          }
        }
      }
    }
  }

  .pageWrap {
    .el-pagination {
      text-align: center;
    }
  }
}
</style>

<style lang="less" scoped>
.recordWrap {
  .recordBar {
    padding: 30px;

    .titleWrap {
      position: relative;
      z-index: 1;
      padding-bottom: 10px;
      margin-bottom: 20px;
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #333333;
      box-sizing: border-box;

      .title {
        font-size: 30px;
      }

      .back {
        position: absolute;
        right: 10px;
        bottom: 5px;
        z-index: 2;
        font-size: 20px;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .tagWrap {
      margin-bottom: 25px;
      display: flex;
      justify-content: space-between;
      gap: 10px;

      span {
        padding-bottom: 2px;
        font-size: 18px;
        border-bottom: 4px solid #ffffff;
        cursor: pointer;
        white-space: nowrap;
      }

      .active {
        font-weight: 600;
        color: #333333;
        border-bottom: 4px solid #D22190;
        cursor: default;
      }
    }

    .searchWrap {
      position: relative;
      z-index: 1;

      .searchBar {
        padding-right: 100px;
        width: 100%;
        box-sizing: border-box;
      }

      .searchBtn {
        position: absolute;
        right: 0;
        bottom: 15px;
        z-index: 1;
        width: 80px;
      }
    }

    .pageWrap {
      padding-top: 13px;
    }
  }
}
</style>
```
